import request from '../utils/request';
const querystring = require('querystring')
 
//获取列表数据
export const fetchData = query => {  
    
    var list = request({
        url: 'comOrderDeduction/selectPage.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
 
//启用-禁用 
export const changeStatus = query => {  
    var list = request({
        url: 'comOrderDeduction/changeStatus.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
//添加渠道信息
export const saveForm = query => {  
    var list = request({
        url: 'comOrderDeduction/insert.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const handDelete = query => {  
    var list = request({
        url: 'comOrderDeduction/delete.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
export const update = query => {  
    var list = request({
        url: 'comOrderDeduction/update.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const updateMore = query => {  
    var list = request({
        url: 'comOrderDeduc/updateMore.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
export const fetchSelect = query => {  
    var list = request({
        url: 'comOrderDeduction/getListFetch.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const getOrderDetail = query => {  
    var list = request({
        url: 'comOrderDeduction/getData.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const getOrderStep = query => {  
    var list = request({
        url: 'comOrderDeduction/getList.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
export const getOrderBack = query => {  
    var list = request({
        url: 'comOrderDeduction/getList.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const changeStatusMore = query => {  
    var list = request({
        url: 'comOrderDeduction/changeStatusMore.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const downOrderExcel = query => {  
    var list = request({
        url: 'comOrderDeduction/getOrderExcel.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};


export const backSys = query => {  
    var list = request({
        url: 'comOrderDeduction/updateByBackSys.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
export const changeDeduc = query => {  
    var list = request({
        url: 'comOrderDeduction/changeDeduc.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const pushMem = query => {  
    var list = request({
        url: 'comOrderDeduc/updateByPushMem.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};